import { render, staticRenderFns } from "./TeamHoldStateComponent.vue?vue&type=template&id=931cdd78&"
import script from "./TeamHoldStateComponent.vue?vue&type=script&lang=ts&"
export * from "./TeamHoldStateComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports